import Sections from './Sections';

export default Sections;
